export const VEHICLE_PLATE_QUESTION_SLUG = 'vehicle_plate';
export const IMPLEMENT_PLATE_QUESTION_SLUG = 'implement_plate';
export const CODE_READER_QUESTION_SLUG = 'code_reader';
export const LOGICAL_QUESTION_SLUG = 'logic';
export const UNIQUE_QUESTION_SLUG = 'unique';
export const IMAGE_QUESTION_SLUG = 'image';
export const VIDEO_QUESTION_SLUG = 'video';
export const VIDEO_VISUALIZATION_QUESTION_SLUG = 'video_visualization';
export const DESCRIPTIVE_QUESTION_SLUG = 'descriptive';

export const QUESTION_TYPES_ALLOWED_TO_HAVE_CHILD_QUESTION = [
  UNIQUE_QUESTION_SLUG,
  'multiple',
  LOGICAL_QUESTION_SLUG,
];

export const QUESTION_TYPES_ALLOWED_TO_CREATE_OCCURRENCE = [
  LOGICAL_QUESTION_SLUG,
  UNIQUE_QUESTION_SLUG,
  'multiple',
];

export const QUESTION_TYPES_ALLOWED_TO_REQUEST_ATTACHMENT = [
  LOGICAL_QUESTION_SLUG,
  UNIQUE_QUESTION_SLUG,
  'multiple',
  DESCRIPTIVE_QUESTION_SLUG,
];

export const QUESTION_TYPES_ALLOWED_TO_REGISTER_ANSWER = [
  UNIQUE_QUESTION_SLUG,
  'multiple',
];

export const QUESTION_TYPES_ALLOWED_TO_HAVE_ANSWER_OPTION = [
  UNIQUE_QUESTION_SLUG,
  'multiple',
  LOGICAL_QUESTION_SLUG,
];

export const QUESTION_TYPES_ALLOWED_TO_HAVE_CORRECT_ANSWER = [
  UNIQUE_QUESTION_SLUG,
  'multiple',
  LOGICAL_QUESTION_SLUG,
];

export const QUESTION_TYPES_WITH_SINGLE_CORRECT_ANSWER = [
  UNIQUE_QUESTION_SLUG,
  LOGICAL_QUESTION_SLUG,
];

export const LOGICAL_QUESTION_ANSWERS = [
  { id: 1, order: 1, description: 'Não' },
  { id: 2, order: 2, description: 'Sim' },
];

export function canSaveVideoVisualizationQuestion(questionType, question) {
  const isVideoVisualizationType =
    questionType?.slug?.toLowerCase() === VIDEO_VISUALIZATION_QUESTION_SLUG;

  return (
    !isVideoVisualizationType ||
    !!question?.mediaId ||
    question?.videoFile instanceof File
  );
}
